// src/features/live-board/components/MetricStamp.tsx
//
// «Coverage and freshness as a stamp, not a warning» (commercial-fit.md
// S6), the same convention `operacion`'s own stamp uses (w7.u2, built on a
// sibling branch this unit does not have access to — duplicated here rather
// than shared, to be reconciled when both branches merge into `candidate`
// in order): one small grey line, identical everywhere. An absent cell
// names its remedy verbatim (02 S1.4) instead of the problem — never
// «estimado», «aproximado», «desconocido». The API states only the remedy
// code (`MetricStampDto.remedies`); the sentence lives in
// `resources.liveBoard.remedies`.
import React from 'react';
import { Typography } from '@mui/material';
import { useLocale, useTranslate } from 'react-admin';
import { DateTimeSystem } from '@/utils/dateTimeSystem';
import type { MetricStampDto } from '@/types/analyticsV2';

const remedyKey = (code: string) => code.replace(/-/g, '_');

interface MetricStampProps {
  stamp: MetricStampDto;
  sx?: object;
}

export const MetricStamp: React.FC<MetricStampProps> = ({ stamp, sx }) => {
  const translate = useTranslate();
  const locale = useLocale();

  if (stamp.remedies.length > 0) {
    const text = stamp.remedies
      .map((code) => translate(`resources.liveBoard.remedies.${remedyKey(code)}`, { minutes: stamp.ingestGapMinutes }))
      .join(' ');
    return (
      <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary', ...sx }}>
        {text}
      </Typography>
    );
  }

  if (!stamp.freshnessAsOf) return null;

  return (
    <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary', ...sx }}>
      {translate('resources.liveBoard.stamp.updated', { relative: DateTimeSystem.formatRelative(stamp.freshnessAsOf, locale) })}
    </Typography>
  );
};

export default MetricStamp;
